<template>
  <div>
    <course-video
      :pic="detailObj.coverPic"
      :detail-obj="detailObj"
      :categories-arr="categoriesArr"
    ></course-video>
    <div class="hasPadding">
      <h5 class="title">{{ detailObj.courseName }}</h5>
      <course-docter-info
        :lec-list="detailObj.lecturerList"
      ></course-docter-info>
      <catalog :catalog-obj="catalogObj"></catalog>
      <div class="course_footer">
        <img class="footer_img" src="http://cdn.yxvzb.com/img/sharetomp.png" />
      </div>
    </div>
    <fan></fan>
  </div>
</template>
<script>
import CourseVideo from './components/CourseVideo2.vue';
import CourseDocterInfo from '@/components/Course/CourseDocterInfo.vue';
import Catalog from './components/Catalog.vue';
import fan from '@/components/fan.vue';
import { mapState } from 'vuex';
import { course, shareCallback } from '@/api/ajax.js';
export default {
  name: '',
  data() {
    return {
      detailObj: {},
      categoriesArr: [],
      isCollection: false,
      isSignIn: false,
      isSignUp: false,
      catalogObj: [],
      channelObj: {},
      playCount: 0
    };
  },
  methods: {
    eventCollection(val) {
      this.isCollection = val;
    },
    toApp() {
      window.location =
        'http://a.app.qq.com/o/simple.jsp?pkgname=com.yxvzb.app';
    },
    getLiveStatus(data) {
      if (data.courseType == 1) {
        //直播中
        let time = new Date().getTime();
        if (data.liveStartTime <= time && time < data.liveEndTime) {
          // 正在直播中
          this.$router.push({
            name: 'liveShare',
            params: { id: this.$route.params.id },
            query: { shareFlag: true }
          });
        }
      } else {
        // 为录播
      }
    },
    getDetail() {
      let data = {
        id: this.$route.params.id
      };
      course.wxdetail(data).then(res => {
        //详情
        this.categoriesArr = this.$api.categoriesFilter(
          res.data.data.categories
        );
        this.detailObj = res.data.data;
        this.isCollection = this.detailObj.isCollection;
        this.isSignIn = this.detailObj.isSignIn;
        // this.playCount = res.data.playCount
        // 判断是否为直播
        this.getLiveStatus(this.detailObj);
        this.catalogObj = this.detailObj.chapters;
        this.channelObj = this.detailObj.relationChannel;
        let wxUserInfoObj = this.$api.getStorage('wxUserInfo') || {};
        let course_from = this.$route.query.shequn ? 'shequn' : 'share';

        let customSA = {};
        if (
          this.$route.query.sourceFrom == 'yabao' &&
          this.$route.query.source_user_id
        ) {
          // 如果是亚宝分享出来的 增加分享着ID
          customSA.source_user_id = this.$route.query.source_user_id;
        }
        let SADATA = {
          ...{
            pageUrl: location.href,
            course_id: this.$route.params.id,
            course_name: this.detailObj.courseName,
            course_type: 'video',
            from: course_from,
            web_edition: 2
          },
          ...customSA
        };
        //进入SC
        sa.track('course_detail', SADATA, function() {});

        /*
         * 分享
         * */
        let shareCallBackFunc = () => {
          shareCallback().then(res => {
            if (res.data.status != '0') {
              //恭喜您分享成功,获得3积分 每天前5次分享均可获得3积分
              this.$vux.toast.show({
                text: '恭喜您获得3积分',
                type: 'success',
                width: '5rem'
              });
            } else {
              //您已获得今天全部分享 积分每天前5次分享均可获得3积分
              this.$vux.toast.show({
                text: '分享成功!',
                type: 'success',
                width: '5rem'
              });
            }
            sa.track(
              'share_total',
              {
                from: 'wx',
                type: 'video',
                target: this.$route.params.id,
                client_id: wxUserInfoObj.id || wxUserInfoObj.wxOpenId || '',
                web_edition: 2
              },
              function() {}
            );

            // 分享埋点
            this.$sa.re_interaction({
              type: '分享', // 评论，送花1，送花2，送花3，送花4，分享，意见反馈，收藏,视频下载
              contentype: 6, // 互动主体 直播，录播，资讯，病例，站内信，论坛
              contentid: this.$route.params.id, // 内容id
              first_cate: '', //一级分类
              second_cate: '', // 2级分类
              first_cate_id: '', // 1级分类id
              second_cate_id: '', //2级分类id
              author: this.detailObj.editor || '', //讲师/作者
              contentname: this.detailObj.courseName,
              source_user_id: this.$route.query.source_user_id || '' // 邀请人ID
              // location:'', //位置 站内，专区内，超级面对面内
            });
          });
        };

        this.$wxShareInfo(
          this.detailObj.courseName,
          this.detailObj.courseName,
          this.detailObj.coverPic,
          location.href,
          '',
          shareCallBackFunc
        );
      });
    }
  },
  computed: {},
  components: {
    CourseVideo,
    CourseDocterInfo,
    Catalog,
    fan
  },
  created() {
    // sessionStorage.vueRouterBackPage = location.href
    this.getDetail();
  }
};
</script>
<style lang="less" scoped>
.title {
  font-size: 0.4266rem;
  margin-top: 0.4rem;
}

.course_footer {
  -webkit-box-sizing: border-box;
  position: relative;
  margin-top: 0.42rem;
  text-align: center;
  font-size: 0.4533rem;
  font-weight: bold;
  padding: 0 0.4rem;
  width: 100%;
  height: 2.9333rem;
  margin-bottom: 0.4rem;
  img {
    width: 100%;
    height: 2.9333rem;
    margin-bottom: 0.4rem;
  }
}
</style>
